const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: ["/terms"],
    exact: true,
    component: "Terms",
  },
  {
    path: ["/privacy"],
    exact: true,
    component: "Privacy",
  },
    {
    path: ["/descargar"],
    exact: true,
    component: "Download",
  },
      {
    path: ["/recados"],
    exact: true,
    component: "Recados",
  },
];

export default routes;
